module.exports = new __parcel__URL__("6afe4676-059a-4aa8-b891-29856bbcba22.e89ae4c8.woff2").toString();